import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { AxiosError } from 'axios';
import { Task } from '../../../types/Task';
import { mutationKeys } from '../mutationKeys';

export const postTask = async (formData: Task) => {
  const response = await CustomAxios.post(`tasks`, formData);
  const { data } = response;
  return data;
};

type useCreateTaskProps = {
  onSuccessCallback: (data: any) => void;
};

export function useCreateTask({ onSuccessCallback }: useCreateTaskProps) {
  return useMutation({
    mutationKey: [mutationKeys.createTask],
    mutationFn: (formData: Task) => postTask(formData),
    onSuccess: (data: any) => {
      // fetch the events again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allTasks, 'new'] });

      // call success
      onSuccessCallback(data);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        // let set the query data with bad errored response
        const task: Task = err.response.data as Task;
        queryClient.setQueryData([queryKeys.allTasks, 'new'], task);
      }
    },
  });
}
